import { Button, Col, Modal, Tag } from "antd";
import React, { CSSProperties, useState } from "react";

import { useCSVReader } from "react-papaparse";

const CSVReader = (props) => {
  const { CSVReader } = useCSVReader();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorList, setErrorList] = useState([]);

  const pushToErrorArray = (i, error, errorArray) => {
    var indexError = errorArray.findIndex((item) => item.row == i);
    if (indexError > -1) {
      errorArray[indexError].error = [...errorArray[indexError].error, error];
    } else {
      errorArray.push({
        row: i,
        error: [error],
      });
    }
    return errorArray;
  };

  return (
    <>
      <CSVReader
        onUploadAccepted={(results) => {
          var array = [...props.dataSource];
          console.log("results", results);
          var error = false;
          var errorArray = [];
          for (var i = 1; i < results.data?.length; i++) {
            if (results.data[i][0]?.length < 1) {
              errorArray.push({
                row: i,
                error: ["Name empty"],
              });
            }
            if (isNaN(results.data[i][3]) && results.data[i][3] != "") {
              errorArray = pushToErrorArray(i, "MRP invalid", errorArray);
              // errorArray.push({
              //   row: i,
              //   error: "MRP invalid",
              // });
            }
            if (isNaN(results.data[i][4]) && results.data[i][4] != "") {
              errorArray = pushToErrorArray(
                i,
                "Landing price invalid",
                errorArray
              );

              // errorArray.push({
              //   row: i,
              //   error: "Landing price invalid",
              // });
            }
            if (isNaN(results.data[i][5]) && results.data[i][5] != "") {
              errorArray = pushToErrorArray(i, "Quantity invalid", errorArray);

              // errorArray.push({
              //   row: i,
              //   error: "quantity invalid",
              // });
            }
            if (isNaN(results.data[i][7]) && results.data[i][7] != "") {
              errorArray = pushToErrorArray(
                i,
                "Invalid gross margin",
                errorArray
              );

              // errorArray.push({
              //   row: i,
              //   error: "Invalid gross margin",
              // });
            }
            if (isNaN(results.data[i][8]) && results.data[i][8] != "") {
              errorArray = pushToErrorArray(i, "Invalid tax value", errorArray);

              // errorArray.push({
              //   row: i,
              //   error: "Invalid tax value",
              // });
            }
            if (errorArray.length == 0) {
              const newData = {
                id:
                  props.dataSource?.length > 0
                    ? props.dataSource?.length + i
                    : i,
                boq_item: results.data[i][0],
                hsn_code: results.data[i][1],
                brand: results.data[i][2],
                mrp: results.data[i][3] ?? "0",
                unit_selling_price: results.data[i][4] ?? "0",
                md_price_gst: results.data[i][4] * 1.18 ?? "0",
                quantity: results.data[i][5] ?? "1",
                unit: results.data[i][6] ?? "sqft",
                gross_margin: results.data[i][7] ?? "0",
                margin:
                  results.data[i][7] / (1 - results.data[i][7] / 100) ?? 0,
                tax_value: results.data[i][8] ?? "18",
                tax_type: "cgst_sgst",
                image: null,
              };
              array.push(newData);
            }
          }
          if (errorArray.length == 0) {
            console.log("array", array);
            props.setDataSource(array);
            props.setShowProductSearchDrawer(false);
          } else {
            console.log("errorArray", errorArray);
            setErrorList(errorArray);
            setShowErrorModal(true);
          }
        }}
      >
        {({ getRootProps, acceptedFile, ProgressBar, getRemoveFileProps }) => (
          <div className="d-flex ml-1">
            {!acceptedFile && (
              <Col>
                <Button type="button" {...getRootProps()}>
                  Add Bulk Items
                </Button>

                <div className="my-2 text-center">
                  <strong>
                    <a
                      href="https://material-depot-content-files.s3.ap-south-1.amazonaws.com/Mysite/pro_forma_bulk_example.csv"
                      download
                    >
                      Download Example
                    </a>
                  </strong>
                </div>
              </Col>
            )}
            {acceptedFile && (
              <Col>
                <div>{acceptedFile.name}</div>

                <div className="my-2 text-center">
                  <strong>
                    <a
                      href="https://material-depot-content-files.s3.ap-south-1.amazonaws.com/Mysite/Bulk+upload+quote+items+-+Sheet1.csv"
                      download
                    >
                      Download Example
                    </a>
                  </strong>
                </div>
              </Col>
            )}

            {acceptedFile && (
              <div className="d-flex justify-center align-items-center ml-1">
                <Tag style={{ cursor: "pointer" }} {...getRemoveFileProps()}>
                  Remove
                </Tag>
              </div>
            )}

            <ProgressBar />
          </div>
        )}
      </CSVReader>
      <Modal
        title="Errors in csv"
        visible={showErrorModal}
        onOk={() => {
          setShowErrorModal(false);
        }}
        onCancel={() => {
          setShowErrorModal(false);
        }}
        width="50%"
        okText="Ok"
        cancelText="Cancel"
      >
        <Col style={{ padding: 16 }}>
          {errorList.map((error) => {
            return (
              <div style={{ padding: 4 }}>
                Row {error?.row} :{"  "}
                {error?.error?.map((item) => {
                  return <Tag color="blue">{item} </Tag>;
                })}
              </div>
            );
          })}
        </Col>
      </Modal>
    </>
  );
};

export default CSVReader;
